export default __webpack_public_path__ + "static/media/error-white.261abbdd.png";